export default function createStyles(styles) {
  if (styles === undefined || Object.keys(styles).length === 0) {
    return {}
  }

  return {
    base: {
      '.circle': {
        width: '50px',
        height: '50px',
        background: styles.circle.background,
        border: '1px solid',
        borderColor: styles.circle.border,
        position: 'absolute',
        top: '22px',
        left: '-12px',
        transform: 'translateY(-50%)',
        '-moz-border-radius': '50px',
        '-webkit-border-radius': '50px',
        borderRadius: '50px',
        textAlign: 'center',
        color: styles.circle.text,
        fontSize: '2.15em',
        padding: '2px 0px 0px 0px'
      },
      '.circle.active': {
        backgroundColor: styles.circleActive.background,
        borderColor: styles.circleActive.border,
        color: styles.circleActive.text
      },
      '.circle.already-complete': {
        backgroundColor: styles.circleComplete.background,
        borderColor: styles.circleComplete.border,
        color: styles.circleComplete.text
      },
      '.list-group-item': { color: styles.fontColor },
      '.list-group-item.active': { color: styles.circleActive.border },
      '.list-group-item .list-group-item-div': {
        border: '1px solid',
        borderColor: styles.circle.text,
        padding: '5px'
      },
      '.listItemText': {
        marginLeft: '40px',
        fontSize: '1.1em'
      },
      '.mobile-image-link': {
        display: 'none',
        position: 'absolute',
        width: '100px',
        backgroundColor: '#eeeeee',
        bottom: '-6px',
        left: '37%',
        textAlign: 'center',
        padding: '3px 0',
        color: '#1a1a1a',
        fontWeight: 'bold',
        fontSize: '12px'
      },
      '.mobile-image-link:hover': { textDecoration: 'underline' },
      mediaQueries: {
        '(max-width: 700px)': {
          '.interactive-device': { display: 'none' },
          '.mobile-image-link': { display: 'block' }
        }
      },
      '.float-right': { float: 'right' },
      '.align-right': {
        textAlign: 'right',
        padding: '10px 25px 5px 15px'
      },
      '.align-left': { padding: '10px 15px 5px 25px' },
      '.align-center': {
        border: 'none !important',
        textAlign: 'center',
        marginBottom: '10px'
      },
      '.align-center > p': { cursor: 'pointer' },
      '.step-ctrl': {
        borderTop: '1px solid',
        borderColor: styles.circle.text,
        color: styles.circleActive.border,
        fontSize: '1.1em',
        marginBottom: '5px'
      },
      '.step-ctrl > p': {
        display: 'inline-block',
        cursor: 'pointer'
      },
      '.disabled': { color: '#ccc' },
      '.scrollarea .scrollbar-container': { zIndex: '100 !important' }
    }
  }
}
